import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import { t } from '../../../../modules/infra/i18n';

const MIN_PAGINATION_ITEMS = 20;

const List = (props) => {
  const { items, columns } = props;

  if (!items || !items.length) {
    return (
      <div>
        {t('products:reports.no_reports_message')}
      </div>
    );
  }

  return (
    <div className="s-v2">
      <ReactTable
        data={items}
        showPagination={items.length > MIN_PAGINATION_ITEMS}
        previousText={t('common:pagination.previous')}
        nextText={t('common:pagination.next')}
        pageText={t('common:pagination.page')}
        ofText={t('common:pagination.of')}
        rowsText={t('common:pagination.rows')}
        minRows={0}
        resizable={false}
        className="c-inventory-report-table ReactTable ReactTable--row-spacing-only c-table-with-sticky-header c-table-new c-table--small c-no-hover"
        columns={columns}
      />
    </div>
  );
};

List.propTypes = {
  items: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

export default List;
